__webpack_require__.p = "https://quiz-trainer.techstarter.academy/";